import { useSelector } from 'store';
import { useGetUserQuery } from 'store/slices/apiV1/user';
import { useMemo } from 'react';
import { isCofactrUser } from 'utils/userPermissions';

export const useIsCofactr = () => {
  const { viewAsStaff } = useSelector((state) => state.user);
  const { data: user } = useGetUserQuery(undefined);
  const isCofactr = useMemo(
    () => isCofactrUser({ user, viewAsStaff }),
    [viewAsStaff, user?.id]
  );
  // Determine if isCofactrUser regardless of viewAsStaff
  const belongsToCofactrOrg = useMemo(
    () => isCofactrUser({ user, viewAsStaff: true }),
    [user?.id]
  );
  return {
    isCofactr,
    user,
    viewAsStaff,
    belongsToCofactrOrg,
  };
};
